import { API } from "../../lib/api";
import { Send, Pencil, Trash2, Eye } from "lucide-react";
import { fmtHijri, fmtSize } from "../../pages/admin/AdminCirculars";

export function CircularTable({ filtered, onEdit, onRemove }) {
  return (
    <div className="bg-surface rounded-2xl border border-brd shadow-md overflow-hidden">
      <div className="overflow-auto">
        <table className="w-full text-sm" data-testid="circulars-table">
          <thead>
            <tr className="bg-bg text-mutext">
              <th className="text-right px-4 py-2.5 font-head text-[11px]">م</th>
              <th className="text-right px-4 py-2.5 font-head text-[11px]">عنوان التعميم</th>
              <th className="text-right px-4 py-2.5 font-head text-[11px]">تاريخ الإصدار</th>
              <th className="text-right px-4 py-2.5 font-head text-[11px]">النوع</th>
              <th className="text-right px-4 py-2.5 font-head text-[11px]">الحجم</th>
              <th className="text-right px-4 py-2.5 font-head text-[11px]">إجراءات</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((c, i) => (
              <tr key={c.id} data-testid={`circular-row-${c.id.slice(0, 8)}`} className="border-b border-brd/50 last:border-0 hover:bg-bg transition-colors">
                <td className="px-4 py-3 text-mutext">{i + 1}</td>
                <td className="px-4 py-3 font-bold flex items-center gap-2">
                  <Send className="w-3.5 h-3.5 text-turq-600 shrink-0" /> {c.title}
                </td>
                <td className="px-4 py-3" dir="ltr">{fmtHijri(c.issue_date)}</td>
                <td className="px-4 py-3 text-[11px] font-bold">{c.file_type || "—"}</td>
                <td className="px-4 py-3 text-[11px]">{fmtSize(c.size)}</td>
                <td className="px-4 py-3">
                  <div className="flex gap-2">
                    {c.storage_path && (
                      <a data-testid={`circular-view-${c.id.slice(0, 8)}`} href={`${API}/portal/circulars/file/${c.id}`} target="_blank" rel="noreferrer"
                        className="h-8 px-3 rounded-lg bg-turq-100 dark:bg-surface2 flex items-center gap-1 text-[11px] font-bold text-turq-900 dark:text-turq-300 hover:scale-105 transition-transform">
                        <Eye className="w-3.5 h-3.5" /> عرض
                      </a>
                    )}
                    <button data-testid={`circular-edit-${c.id.slice(0, 8)}`} onClick={() => onEdit(c)}
                      className="w-8 h-8 rounded-lg bg-beige-600 dark:bg-surface2 flex items-center justify-center hover:scale-105 transition-transform">
                      <Pencil className="w-3.5 h-3.5 text-turq-900 dark:text-turq-300" />
                    </button>
                    <button data-testid={`circular-delete-${c.id.slice(0, 8)}`} onClick={() => onRemove(c)}
                      className="w-8 h-8 rounded-lg bg-coral-100 dark:bg-surface2 flex items-center justify-center hover:scale-105 transition-transform">
                      <Trash2 className="w-3.5 h-3.5 text-coral-900 dark:text-coral-300" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
